var _path, _circle, _circle2, _g, _path2, _path3, _circle3, _circle4, _path4, _path5, _mask, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoConnectionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 140,
    viewBox: "0 0 127 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.1135 139.226C87.1925 139.226 100.227 136.713 100.227 133.613C100.227 130.513 87.1925 128 71.1135 128C55.0346 128 42 130.513 42 133.613C42 136.713 55.0346 139.226 71.1135 139.226Z",
    fill: "#A0A9BA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5494,
    cy: 86.4508,
    r: 48.5494,
    fill: "#EAEEF9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 37,
    width: 98,
    height: 99
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5494,
    cy: 86.4508,
    r: 48.5494,
    fill: "#EAEEF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_967)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.4443,
    y: 24.457,
    width: 70.2099,
    height: 123.988,
    rx: 13.4444,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4443 33.4196C36.4443 30.1196 39.1196 27.4443 42.4196 27.4443H93.2098C100.635 27.4443 106.654 33.4636 106.654 40.8888V103.63C106.654 111.055 100.635 117.074 93.2098 117.074H49.8888C42.4636 117.074 36.4443 111.055 36.4443 103.63V33.4196Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.21 27.4443V33.4196C93.21 36.7197 95.8852 39.395 99.1853 39.395H106.654",
    stroke: "#171923",
    strokeWidth: 1.49383
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 65.5,
    r: 2.75309,
    fill: "#171923",
    stroke: "#171923",
    strokeWidth: 1.49383
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 66.5,
    r: 3.75309,
    fill: "#171923",
    stroke: "#171923",
    strokeWidth: 1.49383
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2471 55.8271C84.8705 57.1135 87.0271 58.1541 88.7716 58.4947C90.0647 58.8148 90.6833 58.8148 91.7162 58.8148",
    stroke: "#171923",
    strokeWidth: 2.24074,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.876 55.8271C53.4994 57.1135 55.656 58.1541 57.4005 58.4947C58.6936 58.8148 59.3123 58.8148 60.3451 58.8148",
    stroke: "#171923",
    strokeWidth: 2.24074,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_78_967",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1052 77.4815C70.5789 77.4815 70.9712 77.8689 70.8811 78.334C70.824 78.6287 70.7373 78.9177 70.6218 79.1965C70.3966 79.7402 70.0665 80.2342 69.6504 80.6504C69.2342 81.0665 68.7402 81.3966 68.1965 81.6218C67.6528 81.847 67.07 81.963 66.4815 81.963C65.893 81.963 65.3102 81.847 64.7665 81.6218C64.2228 81.3966 63.7287 81.0665 63.3126 80.6504C62.8965 80.2342 62.5663 79.7402 62.3411 79.1965C62.2257 78.9177 62.1389 78.6287 62.0818 78.334C61.9917 77.8689 62.384 77.4815 62.8577 77.4815C63.3314 77.4815 63.7028 77.8744 63.8474 78.3255C63.8706 78.398 63.8968 78.4695 63.926 78.54C64.065 78.8756 64.2687 79.1805 64.5256 79.4374C64.7824 79.6942 65.0874 79.898 65.423 80.037C65.7586 80.176 66.1182 80.2475 66.4815 80.2475C66.8447 80.2475 67.2044 80.176 67.54 80.037C67.8756 79.898 68.1805 79.6942 68.4374 79.4374C68.6942 79.1805 68.898 78.8756 69.037 78.54C69.0662 78.4695 69.0924 78.398 69.1156 78.3255C69.2601 77.8744 69.6315 77.4815 70.1052 77.4815Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1052 77.4815C70.5789 77.4815 70.9712 77.8689 70.8811 78.334C70.824 78.6287 70.7373 78.9177 70.6218 79.1965C70.3966 79.7402 70.0665 80.2342 69.6504 80.6504C69.2342 81.0665 68.7402 81.3966 68.1965 81.6218C67.6528 81.847 67.07 81.963 66.4815 81.963C65.893 81.963 65.3102 81.847 64.7665 81.6218C64.2228 81.3966 63.7287 81.0665 63.3126 80.6504C62.8965 80.2342 62.5663 79.7402 62.3411 79.1965C62.2257 78.9177 62.1389 78.6287 62.0818 78.334C61.9917 77.8689 62.384 77.4815 62.8577 77.4815C63.3314 77.4815 63.7028 77.8744 63.8474 78.3255C63.8706 78.398 63.8968 78.4695 63.926 78.54C64.065 78.8756 64.2687 79.1805 64.5256 79.4374C64.7824 79.6942 65.0874 79.898 65.423 80.037C65.7586 80.176 66.1182 80.2475 66.4815 80.2475C66.8447 80.2475 67.2044 80.176 67.54 80.037C67.8756 79.898 68.1805 79.6942 68.4374 79.4374C68.6942 79.1805 68.898 78.8756 69.037 78.54C69.0662 78.4695 69.0924 78.398 69.1156 78.3255C69.2601 77.8744 69.6315 77.4815 70.1052 77.4815Z",
    fill: "#171923",
    stroke: "#171923",
    strokeWidth: 2.98765,
    mask: "url(#path-11-inside-1_78_967)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.9258,
    y: 98,
    width: 61.2469,
    height: 3,
    rx: 1.5,
    fill: "#EAEEF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9258,
    y: 104,
    width: 61.2469,
    height: 3,
    rx: 1.5,
    fill: "#EAEEF9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9258,
    y: 110,
    width: 40.3333,
    height: 3,
    rx: 1.5,
    fill: "#EAEEF9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 19,
    width: 1,
    height: 5,
    rx: 0.5,
    fill: "#171923"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-90 27 29)",
    fill: "#171923"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5264,
    y: 19.7708,
    width: 1.49383,
    height: 6.37632,
    rx: 0.746914,
    transform: "rotate(-30.2698 32.5264 19.7708)",
    fill: "#171923"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.1 21.5999C120.364 21.5999 122.2 19.7643 122.2 17.4999C122.2 15.2355 120.364 13.3999 118.1 13.3999C115.836 13.3999 114 15.2355 114 17.4999C114 19.7643 115.836 21.5999 118.1 21.5999Z",
    fill: "#D7DEEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 67C6.98528 67 9 64.9853 9 62.5C9 60.0147 6.98528 58 4.5 58C2.01472 58 0 60.0147 0 62.5C0 64.9853 2.01472 67 4.5 67Z",
    fill: "#D7DEEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.1 5.6C125.646 5.6 126.9 4.3464 126.9 2.8C126.9 1.2536 125.646 0 124.1 0C122.553 0 121.3 1.2536 121.3 2.8C121.3 4.3464 122.553 5.6 124.1 5.6Z",
    fill: "#D7DEEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnectionIcon);
export default __webpack_public_path__ + "static/media/noConnectionIcon.29725ff3de5175808cad3053c769ddbd.svg";
export { ForwardRef as ReactComponent };